import React, { FC } from "react";
import { css } from "@emotion/css";
import { Theme } from "evcharging/app/themes";
import useTheme from "evcharging/hooks/useTheme";

interface EnergyRatesHeaderProps {
  title: string;
  subTitle: string;
}

const RatesHeader: FC<EnergyRatesHeaderProps> = (props) => {
  const { title, subTitle } = props;
  const theme = useTheme();
  const styles = createStyles(theme);

  return (
    <div className={styles.root}>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.subTitle}>{subTitle}</div>
    </div>
  );
};

const createStyles = (theme: Theme) => (
  {
    root: css`
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      max-width: 306px;
      margin: 0 auto;

      ${theme.breakpoints.mobile.up} {
        max-width: 100%;
        flex-direction: row;
        justify-content: space-between;
      }
    `,
    title: css`
      color: #000;
      font-size: 24px;
      line-height: 28px;
      font-weight: 600;

      ${theme.breakpoints.mobile.up} {
        font-size: 32px;
        line-height: 38px;
      }
    `,
    subTitle: css`
      color: #979797;
      font-size: 16px;
      line-height: 19.2px;
      font-weight: 600;

      ${theme.breakpoints.mobile.up} {
        font-size: 20px;
        line-height: 24px;
      }
    `
  }
);

export default RatesHeader;